import styled from 'styled-components';

export const MobileAppLinksWrapperStyled = styled.div`
    background: var(--color-white);
    color: var(--color-black);
    text-align: center;
    
    h1 {
        font-size: 24px;
        font-weight: 800;
    }
    
    p {
        font-weight: 600;
    }
`;

export const MobileAppLinksDevicesBackgroundStyled = styled.div`
    width: 100%;
    height: 180px;
    background-image: url('/assets/app-links/bg.png');
    background-size: cover;
    background-position-x: 50%;
    background-position-y: 100%;
    margin-bottom: 48px;
`

export const MobileAppLinksButtonsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    a {
        max-width: 210px;
    }
`;
